import React from 'react';
import PropTypes from 'prop-types';
import DownloadModal from './DownloadModalContainer';
import { isIosBridge } from '../../../iosBridge/helpers';
import { t } from '../../../../modules/infra/i18n';

const DownloadButton = ({ currentDate, downloadModalOn, downloadModalOff, downloadModalIsOn }) => {
  return (
    <div className="u-inline-block">
      <button onClick={downloadModalOn} className="c-btn c-btn--medium u-width-120 u-ml-">
        {isIosBridge()
          ? t('register:summary.download_button.export_csv')
          : t('register:summary.download_button.download')}
      </button>
      <DownloadModal currentDate={currentDate} close={downloadModalOff} display-if={downloadModalIsOn} />
    </div>
  );
};

DownloadButton.propTypes = {
  downloadModalOn: PropTypes.func.isRequired,
  downloadModalOff: PropTypes.func.isRequired,
  downloadModalIsOn: PropTypes.bool.isRequired,
  currentDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,
};

export default DownloadButton;
